const sectionIcon = require('./../../../../../../assets/icons/section.svg');
const labelIcon = require('./../../../../../../assets/icons/label.svg');
const spacerIcon = require('./../../../../../../assets/icons/spacer.svg');
const textInputIcon = require('./../../../../../../assets/icons/textInput.svg');
const textAreaIcon = require('./../../../../../../assets/icons/textArea.svg');
const yesNoQuestionIcon = require('./../../../../../../assets/icons/yesNoQuestion.svg');
const checkboxIcon = require('./../../../../../../assets/icons/checkBox.svg');
const checkboxGroupIcon = require('./../../../../../../assets/icons/checkBoxGroup.svg');
const multiSelectIcon = require('./../../../../../../assets/icons/checkBoxGroup.svg');
const radioButtonGroupIcon = require('./../../../../../../assets/icons/radioButtonGroup.svg');
const dropdownIcon = require('./../../../../../../assets/icons/dropDown.svg');
const rowRepeaterIcon = require('./../../../../../../assets/icons/rowRepeater.svg');
const dateCalendarIcon = require('./../../../../../../assets/icons/dateCalendar.svg');
const classCodePickerIcon = require('./../../../../../../assets/icons/classCodePicker.svg');
const functionButtonIcon = require('./../../../../../../assets/icons/functionButton.svg');
const urlLinkIcon = require('./../../../../../../assets/icons/urlLink.svg');
const uploadAttachmentIcon = require('./../../../../../../assets/icons/uploadAttachment.svg');
const formSummaryGridIcon = require('./../../../../../../assets/icons/formSummaryGrid.svg');

/*@ngInject*/
const ComponentPaletteController = function ($element, localization, fieldType) {
    $element.addClass('componentPalette');

    localization.getTranslations().then(function (translations) {

        // Hardcoded for now, but we could imagine a scenario in the future where we could build this with input from
        // a call to the server, etc.
        this.paletteButtons = [{
            name: 'section',
            label: _.get(translations, 'componentPalette.section.label'),
            iconSrc: sectionIcon,
            type: -1,
            formTemplateType: this.formTemplateType
        }, {
            name: 'label',
            label: _.get(translations, 'componentPalette.label.label'),
            iconSrc: labelIcon,
            type: fieldType.LABEL,
            formTemplateType: this.formTemplateType
        }, {
            name: 'spacer',
            label: _.get(translations, 'componentPalette.spacer.label'),
            iconSrc: spacerIcon,
            type: fieldType.SPACER,
            formTemplateType: this.formTemplateType
        }, {
            name: 'textInput',
            label: _.get(translations, 'componentPalette.textInput.label'),
            iconSrc: textInputIcon,
            type: fieldType.TEXT_INPUT,
            formTemplateType: this.formTemplateType
        }, {
            name: 'textArea',
            label: _.get(translations, 'componentPalette.textArea.label'),
            iconSrc: textAreaIcon,
            type: fieldType.TEXT_AREA,
            formTemplateType: this.formTemplateType
        }, {
            name: 'yesNoQuestion',
            label: _.get(translations, 'componentPalette.yesNoQuestion.label'),
            iconSrc: yesNoQuestionIcon,
            type: fieldType.YES_NO,
            formTemplateType: this.formTemplateType
        }, {
            name: 'checkBox',
            label: _.get(translations, 'componentPalette.checkBox.label'),
            iconSrc: checkboxIcon,
            type: fieldType.CHECK_BOX,
            formTemplateType: this.formTemplateType
        }, {
            name: 'checkBoxGroup',
            label: _.get(translations, 'componentPalette.checkBoxGroup.label'),
            iconSrc: checkboxGroupIcon,
            type: fieldType.CHECK_BOX_GROUP,
            formTemplateType: this.formTemplateType
        }, {
            name: 'radioButtonGroup',
            label: _.get(translations, 'componentPalette.radioButtonGroup.label'),
            iconSrc: radioButtonGroupIcon,
            type: fieldType.RADIO_BUTTON_GROUP,
            formTemplateType: this.formTemplateType
        }, {
            name: 'dropDown',
            label: _.get(translations, 'componentPalette.dropDown.label'),
            iconSrc: dropdownIcon,
            type: fieldType.DROP_DOWN,
            formTemplateType: this.formTemplateType
        }, {
            name: 'multiSelect',
            label: _.get(translations, 'componentPalette.multiSelect.label'),
            iconSrc: multiSelectIcon,
            type: fieldType.MULTI_SELECT,
            formTemplateType: this.formTemplateType
        }, {
            name: 'rowRepeater',
            label: _.get(translations, 'componentPalette.rowRepeater.label'),
            iconSrc: rowRepeaterIcon,
            type: fieldType.ROWREPEATER,
            formTemplateType: this.formTemplateType
        }, {
            name: 'dateCalendar',
            label: _.get(translations, 'componentPalette.dateCalendar.label'),
            iconSrc: dateCalendarIcon,
            type: fieldType.CALENDAR,
            formTemplateType: this.formTemplateType
        }, {
            name: 'classCodePicker',
            label: _.get(translations, 'componentPalette.classCodePicker.label'),
            iconSrc: classCodePickerIcon,
            type: fieldType.CLASSCODEFINDER,
            formTemplateType: this.formTemplateType
        }, {
            name: 'functionButton',
            label: _.get(translations, 'componentPalette.functionButton.label'),
            iconSrc: functionButtonIcon,
            type: fieldType.FUNCTION_BUTTON,
            formTemplateType: this.formTemplateType
        }, {
            name: 'urlLink',
            label: _.get(translations, 'componentPalette.urlLink.label'),
            iconSrc: urlLinkIcon,
            type: fieldType.LINK_BUTTON,
            formTemplateType: this.formTemplateType
        }, {
            name: 'uploadAttachment',
            label: _.get(translations, 'componentPalette.uploadAttachment.label'),
            iconSrc: uploadAttachmentIcon,
            type: fieldType.UPLOAD_ATTACHMENT_BUTTON,
            formTemplateType: this.formTemplateType
        }, {
            name: 'formSummaryGrid',
            label: _.get(translations, 'componentPalette.formSummaryGrid.label'),
            iconSrc: formSummaryGridIcon,
            type: fieldType.FORM_SUMMARY_GRID,
            formTemplateType: this.formTemplateType
        }];

        this.onPaletteButtonClick = function (paletteButton) {
            // TODO
        };
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('componentPaletteController', ComponentPaletteController);
